module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-269.dd54aee.woff2";